<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >
    <b-modal
      v-model="showPopup"
      centered
      modal-class="app-popup-shell catalog-detail-shell"
      dialog-class="app-popup-dialog catalog-detail-dialog"
      content-class="app-popup-content catalog-detail-content"
      body-class="app-popup-body catalog-detail-body"
      :hide-footer="true"
      size="xl"
      title=""
      header-class="app-popup-header"
    >
      <Detail
        v-if="toEditItem !== null"
        :__item="toEditItem"
        @close="closePopup"
      ></Detail>
    </b-modal>

    <div class="pageHeader">
      <div class="subMenu">
        <button class="subMenu-toggler" @click="subMenuOpen = !subMenuOpen">
          <b-icon :icon="subMenuOpen ? 'x' : 'list'" font-scale="1.4"></b-icon>
        </button>

        <div
          class="subMenu-content"
          :class="{ 'subMenu-content-open': subMenuOpen }"
        >
          <b-nav pills class="subMenu-nav">
            <b-nav-item
              :link-classes="navItemClasses(['/catalogue'])"
              @click="goProd"
            >
              Catalogue produits
            </b-nav-item>

            <b-nav-item
              :link-classes="navItemClasses(['/a-propos'])"
              @click="goPage('about')"
            >
              À propos de nous
            </b-nav-item>

            <div
              class="subMenuDropdown"
              @mouseenter="servicesMenuOpen = true"
              @mouseleave="servicesMenuOpen = false"
            >
              <button
                type="button"
                class="subMenuDropdownToggle"
                :class="{ 'nav-link-active': isRouteActive(['/nos-services', '/services']) }"
                @click="goPage('services')"
              >
                <span>Nos services</span>
                <b-icon icon="chevron-down" class="subMenuDropdownCaret"></b-icon>
              </button>

              <div
                class="subMenuDropdownMenu"
                :class="{ 'subMenuDropdownMenu-open': servicesMenuOpen }"
              >
                <button type="button" class="subMenuDropdownItem" @click="goPage('service-parts')">
                  Pièces de rechange
                </button>
                <button type="button" class="subMenuDropdownItem" @click="goPage('service-airports')">
                  Fourniture aéroports
                </button>
                <button type="button" class="subMenuDropdownItem" @click="goPage('service-training')">
                  Formation et Conseil
                </button>
              </div>
            </div>

            <b-nav-item
              :link-classes="navItemClasses(['/formations-et-conseils'])"
              @click="goPage('training')"
            >
              Formations &amp; conseils
            </b-nav-item>

            <b-nav-item
              :link-classes="navItemClasses(['/contact'])"
              @click="goPage('contact')"
            >
              Contact
            </b-nav-item>
          </b-nav>

          <div class="reso">
            <b-icon icon="telephone-forward-fill" aria-hidden="true"></b-icon>
            <span>(+216) 70 836 528</span>
            <b-icon icon="facebook" aria-hidden="true"></b-icon>
            <b-icon icon="linkedin" aria-hidden="true"></b-icon>
            <b-icon icon="instagram" aria-hidden="true"></b-icon>
          </div>
        </div>
      </div>
    </div>

    <div
      class="page-content-wrapper"
      v-if="currentPublicPage"
      v-html="currentPublicPage.content"
    ></div>

    <div class="row mainPanelWithoutFilter" v-if="isCatalogView">
      <div class="catalogHeroCard">
        <carrousel></carrousel>
      </div>

      <div class="catalogIntro">
        <div class="catalogIntro-copy">
          <div class="catalogIntro-kicker">
            {{ typeCatalogue === "PRD" ? "Catalogue pièces & composants" : "Catalogue prestations & interventions" }}
          </div>
          <h1 class="catalogIntro-title">
            {{ typeCatalogue === "PRD" ? "Trouvez rapidement la bonne pièce" : "Découvrez nos services techniques" }}
          </h1>
          <p class="catalogIntro-text">
            {{
              typeCatalogue === "PRD"
                ? "Un catalogue clair pour identifier vos références, comparer les familles de produits et demander un devis en quelques clics."
                : "Un espace plus lisible pour parcourir nos prestations, filtrer par catégorie et envoyer vos demandes plus vite."
            }}
          </p>
        </div>

        <div class="catalogIntro-stats">
          <div class="catalogStat">
            <span class="catalogStat-value">
              <span v-if="!statsReady" class="catalogStat-skeleton"></span>
              <span v-else>{{ totalRows }}</span>
            </span>
            <span class="catalogStat-label">articles visibles</span>
          </div>
          <div class="catalogStat">
            <span class="catalogStat-value">{{ perPage }}</span>
            <span class="catalogStat-label">par page</span>
          </div>
        </div>
      </div>

      <div class="row serachPanel">
        <div class="col-md-6 searchField">
          <div class="searchField-label">Désignation</div>
          <base-input
            placeholder="Filtre désignation"
            v-model="filterContainer.keySearchDes"
            type="string"
          >
          </base-input>
        </div>

        <div class="col-md-6 searchField">
          <div class="searchField-label">Catégories produits</div>
          <selector
            ref="selectorCatalogue"
            v-if="toEditOption !== filterCatalogue"
            :_id="filterCatalogue"
            :_editable="true"
            :_asFilter="true"
            :_showTitle="false"
            :_initFn="setCatData"
            :_parentItem="filterContainer"
            _warpper="filter_catID"
          ></selector>
        </div>
      </div>

      <div
        v-for="(item, index) in paginatedListitems"
        :key="index"
        :class="[styleSublisteMode + isCurrent(index === showList), { 'catalogCard-admin': isAdmin }]"
        v-if="__idxOnEdition === -1 || __idxOnEdition === index"
      >
        <div class="catalogCard-media" @click="dispatchEdit(item)">
          <div class="pic">
            <img :src="getTof(item.pic)" alt="Produit catalogue ITTEC P&M" />
          </div>
        </div>

        <div class="catalogCard-body" @click="dispatchEdit(item)">
          <div class="catalogCard-category">{{ item.catID }}</div>
          <div class="catalogCard-ref">{{ item.ref }}</div>
          <div class="catalogCard-name">{{ item.name }}</div>
          <div class="catalogCard-action">Voir le détail</div>
        </div>
      </div>

      <div class="catalogPagination" v-if="showPagination">
        <div class="catalogPagination-info">
          {{ paginationLabel }}
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          pills
          align="center"
          class="mb-0"
        ></b-pagination>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import Detail from "./Detail";
import carrousel from "./carrousel";
import { PUBLIC_PAGE_MAP } from "@/helpers/labels";

const PROD_CATALOG_ID = "676c8c21590157a748c9c8b6";
const SERVICE_CATALOG_ID = "676c8c53590157a748c9c8b8";

export default {
  components: {
    carrousel,
    Detail,
  },
  props: {
    __idxOnEdition: {
      type: Number,
      default: () => -1,
    },
    __isOnLoad: {
      type: Boolean,
      default: () => false,
    },
    __list: {
      type: Array,
      default: () => [],
    },
    __editMode: {
      type: Boolean,
      default: () => false,
    },
    __onSelect: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    publicPageSlug: {
      type: String,
      default: () => null,
    },
    catalogMode: {
      type: String,
      default: () => null,
    },
    isAdmin: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      filterContainer: { keySearchRef: "", keySearchDes: "", filter_catID: "" },
      structure: { vCat: [], vMarque: [] },
      showPopup: null,
      showMenu: -1,
      showList: -1,
      toEditItem: null,
      filtredListitems: [],
      toEditOption: "",
      errorCtrl: [],
      typeCatalogue: this.catalogMode || "PRD",
      filterCatalogue:
        this.catalogMode === "SRV" ? SERVICE_CATALOG_ID : PROD_CATALOG_ID,
      subMenuOpen: false,
      servicesMenuOpen: false,
      currentPage: 1,
      perPage: 24,
      statsReady: false,
    };
  },

  computed: {
    currentPublicPage() {
      if (!this.publicPageSlug) {
        return null;
      }

      return PUBLIC_PAGE_MAP[this.publicPageSlug] || null;
    },
    isCatalogView() {
      return this.currentPublicPage === null;
    },
    styleSublisteMode() {
      return this.__editMode !== true
        ? "listeMode catalogCard col-md-3"
        : "editMode col-md-12";
    },
    totalRows() {
      return this.filtredListitems.length;
    },
    paginatedListitems() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filtredListitems.slice(start, start + this.perPage);
    },
    showPagination() {
      return this.totalRows > this.perPage;
    },
    paginationLabel() {
      if (this.totalRows === 0) {
        return "Aucun article";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.totalRows);
      return `${start}-${end} sur ${this.totalRows} articles`;
    },
  },

  methods: {
    navigateTo(path) {
      this.subMenuOpen = false;
      this.servicesMenuOpen = false;

      if (this.$route.path === path) {
        return;
      }

      this.$router.push(path);
    },
    goPage(slug) {
      const page = PUBLIC_PAGE_MAP[slug];

      if (!page) {
        return;
      }

      this.navigateTo(page.path);
    },
    resetCatalogFilters() {
      this.filterContainer = {
        keySearchRef: "",
        keySearchDes: "",
        filter_catID: "",
      };
      this.currentPage = 1;
      this.showList = -1;
    },
    refreshSelector() {
      this.$nextTick(() => {
        if (
          this.$refs.selectorCatalogue &&
          this.$refs.selectorCatalogue.loadData
        ) {
          this.$refs.selectorCatalogue.loadData();
        }
      });
    },
    loadCatalogSelection(mode = "PRD", reloadParent = true) {
      this.typeCatalogue = mode;
      this.filterCatalogue =
        mode === "SRV" ? SERVICE_CATALOG_ID : PROD_CATALOG_ID;
      this.resetCatalogFilters();

      if (this.$parent) {
        this.$parent.moduleRoute = mode === "SRV" ? "/services" : "/prods";
        if (reloadParent && this.$parent.loadData) {
          this.$parent.loadData();
        }
      }

      this.refreshSelector();
    },
    goProd() {
      if (this.$route.path !== "/catalogue") {
        this.navigateTo("/catalogue");
        return;
      }

      this.loadCatalogSelection("PRD");
    },
    navItemClasses(paths) {
      return this.isRouteActive(paths) ? "nav-link-active" : "";
    },
    dropdownToggleClass(paths) {
      return this.isRouteActive(paths)
        ? "nav-link-custom nav-link-active"
        : "nav-link-custom";
    },
    isRouteActive(paths = []) {
      return paths.some((path) => {
        return (
          this.$route.path === path || this.$route.path.startsWith(`${path}/`)
        );
      });
    },
    filtredList() {
      let ret = Array.isArray(this.__list) ? [...this.__list] : [];
      const searchValue = (this.filterContainer.keySearchDes || "").trim().toLowerCase();

      if (searchValue) {
        ret = ret.filter((item) => {
          const label = `${item.name || ""} ${item.ref || ""}`.toLowerCase();
          return label.includes(searchValue);
        });
      }

      if (this.filterContainer.filter_catID) {
        ret = ret.filter((item) => item.catID === this.filterContainer.filter_catID);
      }

      this.filtredListitems = ret
        .map((item, index) => ({ item, index }))
        .sort((left, right) => {
          const leftHasPhoto = !!left.item.pic;
          const rightHasPhoto = !!right.item.pic;

          if (leftHasPhoto === rightHasPhoto) {
            return left.index - right.index;
          }

          return leftHasPhoto ? -1 : 1;
        })
        .map(({ item }) => item);
      this.normalizeCurrentPage();
    },
    setCatData(list) {
      this.structure.vCat = list;
    },
    dispatchEdit(item) {
      this.toEditItem = item;
      this.toEditItem.typeArticle = this.typeCatalogue;
      this.showPopup = true;
    },
    closePopup() {
      this.toEditItem = null;
      this.showPopup = false;
    },
    isCurrent(current) {
      if (this.showList !== -1) {
        return current ? " actif" : " flowted";
      }
      return "";
    },
    getTof(filePath) {
      return this.__.resolveMediaPath(filePath, "uploads/catalogue/No-Image.jpg");
    },
    normalizeCurrentPage() {
      const totalPages = Math.max(
        1,
        Math.ceil(this.filtredListitems.length / this.perPage)
      );

      if (this.currentPage > totalPages) {
        this.currentPage = totalPages;
      }
      if (this.currentPage < 1) {
        this.currentPage = 1;
      }
    },
  },

  mounted() {
    this.filtredList();
    this.statsReady = !this.__isOnLoad && this.__list.length > 0;

    if (this.isCatalogView) {
      this.loadCatalogSelection(this.typeCatalogue, false);
    }
  },

  watch: {
    __idxOnEdition: {
      deep: true,
      handler() {
        this.filtredList();
      },
    },
    __list: {
      deep: true,
      handler() {
        if (Array.isArray(this.__list) && this.__list.length > 0) {
          this.statsReady = true;
        }
        this.filtredList();
      },
    },
    filterContainer: {
      deep: true,
      handler() {
        this.currentPage = 1;
        this.filtredList();
      },
    },
    __isOnLoad(value, oldValue) {
      if (oldValue === true && value === false) {
        this.statsReady = true;
      }
    },
  },
};
</script>

<style scoped>
.catalogCard {
  flex: 0 0 23.5%;
  max-width: 23.5%;
  margin-bottom: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #e1e8f0;
  border-radius: 20px;
  overflow: hidden;
  transition: box-shadow 0.22s ease, transform 0.22s ease, border-color 0.22s ease;
  cursor: pointer;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.08);
  padding: 14px;
}

.catalogCard:hover {
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.14);
  transform: translateY(-3px);
  border-color: #d1ddeb;
}

.catalogCard-media {
  margin-bottom: 14px;
}

.catalogHeroCard {
  width: 100%;
  max-width: 1140px;
  margin: 92px auto 18px;
  padding: 14px;
  border-radius: 28px;
  background: linear-gradient(180deg, #ffffff 0%, #f6f9fc 100%);
  border: 1px solid #dde6f0;
  box-shadow: 0 22px 48px rgba(15, 23, 42, 0.1);
}

.catalogIntro {
  width: 100%;
  max-width: 1140px;
  margin: 0 auto 18px;
  padding: 22px 24px;
  border-radius: 24px;
  background: linear-gradient(135deg, #1f2740 0%, #26385c 100%);
  box-shadow: 0 20px 42px rgba(15, 23, 42, 0.16);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  color: #fff;
}

.catalogIntro-copy {
  max-width: 760px;
}

.catalogIntro-kicker {
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.74);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.catalogIntro-title {
  margin: 0 0 10px;
  font-size: 34px;
  line-height: 1.06;
  color: #fff;
}

.catalogIntro-text {
  margin: 0;
  color: rgba(255, 255, 255, 0.84);
  font-size: 15px;
  line-height: 1.6;
}

.catalogIntro-stats {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.catalogStat {
  min-width: 122px;
  padding: 14px 16px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.14);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.catalogStat-value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}

.catalogStat-skeleton {
  display: inline-block;
  width: 54px;
  height: 28px;
  border-radius: 999px;
  background: linear-gradient(90deg, #dbe7f4 0%, #eff5fb 50%, #dbe7f4 100%);
  background-size: 180% 100%;
  animation: catalogStatPulse 1.15s ease-in-out infinite;
}

.catalogStat-label {
  color: rgba(255, 255, 255, 0.76);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

@keyframes catalogStatPulse {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 180% 0;
  }
}

.catalogCard .catalogCard-media .pic {
  width: 100%;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: linear-gradient(180deg, #f8fbfe 0%, #eef3f7 100%);
  border: 1px solid #e5ebf3;
  overflow: hidden;
}

.catalogCard .catalogCard-media .pic img {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain;
  padding: 16px;
  transition: transform 0.3s ease;
  mix-blend-mode: darken;
}

.catalogCard:hover .catalogCard-media .pic img {
  transform: scale(1.03);
}

.catalogCard-admin .catalogCard-media .pic {
  width: 100%;
  min-height: 212px;
  height: 212px;
  padding: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f5f8fc 100%);
}

.catalogCard-admin .catalogCard-media .pic img {
  width: 100% !important;
  height: 100% !important;
  padding: 0;
  object-fit: contain;
  object-position: center center;
  transform: scale(1);
  mix-blend-mode: normal;
}

.catalogCard-admin:hover .catalogCard-media .pic img {
  transform: scale(1.06);
}

.catalogCard-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 126px;
}

.catalogCard-category {
  font-size: 11px;
  font-weight: 700;
  color: #6d7b93;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.catalogCard-ref {
  color: #7b879c;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
}

.catalogCard-name {
  color: #1e2a44;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.18;
}

.catalogCard-action {
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 14px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f59d2a 0%, #f1851b 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 12px 24px rgba(241, 133, 27, 0.22);
}

.pageHeader {
  position: fixed;
  top: 120px;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 333;
  background: linear-gradient(135deg, #1e1e2f 0%, #2d2d44 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.subMenu {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 18px;
  min-height: 72px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}

.subMenu-toggler {
  display: none;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 10px 15px;
}

.subMenu-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  gap: 16px;
}

.subMenu-nav {
  display: flex;
  align-items: center;
  gap: 6px;
}

.subMenuDropdown {
  position: relative;
  display: flex;
  align-items: center;
}

.subMenuDropdownToggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.88);
  font-size: 14px;
  font-weight: 600;
  padding: 10px 14px;
  border-radius: 12px;
  transition: color 0.2s, background 0.2s, transform 0.2s;
  white-space: nowrap;
  letter-spacing: 0.02em;
}

.subMenuDropdownToggle:hover,
.subMenuDropdownToggle.nav-link-active {
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-1px);
}

.subMenuDropdownCaret {
  font-size: 11px;
  opacity: 0.82;
}

.subMenuDropdownMenu {
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  min-width: 220px;
  padding: 10px;
  border: 1px solid #dbe4f0;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 24px 54px rgba(15, 23, 42, 0.16);
  opacity: 0;
  visibility: hidden;
  transform: translateY(8px);
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
  z-index: 12;
}

.subMenuDropdownMenu-open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.subMenuDropdownItem {
  width: 100%;
  border: 0;
  background: transparent;
  border-radius: 12px;
  padding: 10px 12px;
  color: #1e2a44;
  font-weight: 600;
  text-align: left;
}

.subMenuDropdownItem:hover {
  background: #eef4fb;
  color: #1e2a44;
}

.subMenu >>> .nav-link {
  color: rgba(255, 255, 255, 0.88) !important;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 14px;
  border-radius: 12px;
  transition: color 0.2s, background 0.2s, transform 0.2s;
  white-space: nowrap;
  letter-spacing: 0.02em;
}

.subMenu >>> .nav-link:hover,
.subMenu >>> .nav-link-active {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-1px);
}

.subMenu :deep(.dropdown-toggle) {
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.subMenu :deep(.dropdown-menu) {
  margin-top: 12px;
  border: 1px solid #dbe4f0;
  border-radius: 18px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 24px 54px rgba(15, 23, 42, 0.16);
}

.subMenu :deep(.dropdown-item) {
  border-radius: 12px;
  padding: 10px 12px;
  color: #1e2a44;
  font-weight: 600;
}

.subMenu :deep(.dropdown-item:hover) {
  background: #eef4fb;
  color: #1e2a44;
}

.reso {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #f59d2a 0%, #f1851b 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 999px;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 12px 28px rgba(241, 133, 27, 0.22);
}

.reso span {
  margin-right: 4px;
}

.reso .b-icon {
  margin: 0;
  cursor: pointer;
  opacity: 0.9;
  transition: opacity 0.2s, transform 0.2s;
}

.reso .b-icon:hover {
  opacity: 1;
  transform: scale(1.15);
}

.serachPanel {
  padding: 18px 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f6f9fc 100%);
  border: 1px solid #e2e8f0;
  width: 100%;
  max-width: 1140px;
  margin: 0 auto 18px;
  border-radius: 20px;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.06);
}

.searchField-label {
  margin-bottom: 8px;
  color: #6b7890;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.editMode {
  float: left;
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}

.editMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}

.listeMode {
  min-height: 40px;
}

.flowted {
  filter: blur(3.5px);
}

.actif {
  filter: none;
  background-color: #131016;
}

.mainPanelWithoutFilter {
  max-width: 1140px;
  margin: 50px auto 0 auto;
  padding: 0 15px;
  justify-content: center;
  column-gap: 18px;
}

.catalogPagination {
  width: 100%;
  padding: 18px 0 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.catalogPagination-info {
  color: #6c757d;
  font-size: 14px;
  text-align: center;
}

.catalogPagination >>> .page-link {
  color: #1e1e2f;
  border-color: #d7dbe0;
  min-width: 44px;
  height: 44px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  border-radius: 14px !important;
  margin: 0 4px;
  box-shadow: 0 6px 16px rgba(30, 42, 68, 0.08);
}

.catalogPagination >>> .page-item.active .page-link {
  background: #f1851b;
  border-color: #f1851b;
  color: #fff;
}

.catalogPagination >>> .page-item.disabled .page-link {
  opacity: 0.55;
}

:deep(.catalog-detail-shell .modal-dialog) {
  max-width: 1140px !important;
}

:deep(.catalog-detail-body) {
  padding-top: 12px !important;
}

@media (max-width: 992px) {
  .catalogCard {
    flex: 0 0 31%;
    max-width: 31%;
  }
}

@media (max-width: 768px) {
  .catalogCard {
    flex: 0 0 48%;
    max-width: 48%;
    margin-bottom: 12px;
  }

  .catalogHeroCard {
    margin-top: 74px;
    padding: 10px;
    border-radius: 22px;
  }

  .catalogIntro {
    padding: 18px 16px;
    border-radius: 20px;
    flex-direction: column;
    align-items: flex-start;
  }

  .catalogIntro-title {
    font-size: 28px;
  }

  .catalogIntro-stats {
    width: 100%;
  }

  .catalogStat {
    flex: 1 1 0;
  }

  .pageHeader {
    top: 50px;
    width: 100vw;
  }

  .subMenu {
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: 0;
    max-width: 100%;
    min-height: 50px;
  }

  .subMenu-toggler {
    display: block;
  }

  .subMenu-content {
    display: none;
    flex-direction: column;
    align-items: stretch;
    position: absolute;
    top: 36px;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, #1e1e2f 0%, #2d2d44 100%);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    padding: 10px 0;
  }

  .subMenu-content-open {
    display: flex;
  }

  .subMenu-nav {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding: 0 10px;
  }

  .subMenuDropdown {
    width: 100%;
  }

  .subMenuDropdownToggle {
    width: 100%;
    justify-content: space-between;
  }

  .subMenuDropdownMenu {
    position: static;
    min-width: 0;
    margin: 6px 10px 0;
    opacity: 1;
    visibility: visible;
    transform: none;
    display: none;
  }

  .subMenuDropdownMenu-open {
    display: block;
  }

  .reso {
    justify-content: center;
    border-radius: 0;
    font-size: 12px;
    padding: 10px;
    margin-top: 6px;
  }

  .mainPanelWithoutFilter {
    margin-top: 40px;
  }

  .serachPanel {
    padding: 10px;
    border-radius: 0;
  }

  .serachPanel .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 5px;
  }
}

@media (max-width: 480px) {
  .catalogCard {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .catalogIntro-title {
    font-size: 24px;
  }

  .catalogIntro-stats {
    flex-direction: column;
  }

  .catalogCard .catalogCard-media .pic {
    height: 146px;
  }

  .catalogCard-admin .catalogCard-media .pic {
    min-height: 176px;
    height: 176px;
  }

  .catalogCard-name {
    font-size: 18px;
  }

  .reso {
    font-size: 11px;
    padding: 6px 8px;
    gap: 5px;
  }

  .subMenu >>> .nav-link {
    font-size: 12px;
    padding: 8px 10px;
  }
}
</style>

<style>
.page-content-wrapper {
  max-width: 1140px;
  margin: 134px auto 40px auto;
  padding: 0 15px;
}

.publicPage {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.publicHero {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(320px, 0.92fr);
  gap: 24px;
  align-items: stretch;
}

.publicHero-reversed {
  grid-template-columns: minmax(0, 0.96fr) minmax(320px, 1.04fr);
}

.publicHero-copy,
.publicHero-media,
.publicHighlight-card,
.publicContactPanel,
.publicMapCard,
.publicFeatureCard,
.publicTimeline-card,
.publicCallout,
.publicContactCard {
  border-radius: 28px;
  border: 1px solid #e0e7f0;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
}

.publicHero-copy {
  padding: 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.publicHero-title {
  margin: 8px 0 12px;
  color: #1e2a44;
  font-size: 44px;
  line-height: 1.08;
  font-weight: 800;
}

.publicHero-text,
.publicPageHeroCenter p,
.publicSection-head p,
.publicHighlight-card p,
.publicContactCard p,
.publicTimeline-card p,
.publicFeatureCard-body p {
  color: #4f5f78;
  font-size: 14px;
  line-height: 1.72;
  margin: 0;
}

.publicHero-media {
  overflow: hidden;
  background: #fff;
}

.publicHero-media img,
.publicFeatureCard img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.publicEyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #f1851b;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.publicEyebrow-light {
  color: rgba(255, 255, 255, 0.72);
}

.publicMiniStats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 16px;
}

.publicMiniStat {
  padding: 14px 14px 12px;
  border-radius: 16px;
  background: #f5f8fc;
  border: 1px solid #e3eaf2;
}

.publicMiniStat strong {
  display: block;
  margin-bottom: 6px;
  color: #1e2a44;
  font-size: 14px;
}

.publicMiniStat span {
  color: #65758c;
  font-size: 13px;
  line-height: 1.5;
}

.publicHighlight-card {
  padding: 24px 26px;
  background: linear-gradient(135deg, #1f2740 0%, #273960 100%);
}

.publicHighlight-card h2,
.publicHighlight-card p,
.publicHighlight-card li {
  color: #f9fbff;
}

.publicHighlight-card h2 {
  margin: 8px 0 12px;
  font-size: 26px;
  line-height: 1.16;
  font-weight: 800;
}

.publicHighlight-card p {
  color: rgba(255, 255, 255, 0.92);
}

.publicHighlight-split {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.publicHighlight-card-alt {
  background: linear-gradient(135deg, #2b3961 0%, #324572 100%);
}

.publicSection {
  padding: 4px 0;
}

.publicSection-head {
  max-width: 720px;
  margin-bottom: 18px;
}

.publicSection-head h2,
.publicPageHeroCenter h1,
.publicCallout h2 {
  margin: 8px 0 10px;
  color: #1e2a44;
  font-size: 38px;
  line-height: 1.1;
  font-weight: 800;
}

.publicFeatureGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.publicFeatureGrid-services {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.publicFeatureCard {
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  transition: transform 0.24s ease, box-shadow 0.24s ease;
}

.publicFeatureCard:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.12);
}

.publicFeatureCard img {
  height: 200px;
}

.publicFeatureCard-body {
  padding: 18px 18px 20px;
}

.publicFeatureCard-body h2,
.publicFeatureCard-body h3,
.publicTimeline-card h3 {
  margin: 0 0 8px;
  color: #1e2a44;
  font-size: 24px;
  line-height: 1.16;
  font-weight: 800;
}

.publicBulletGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 28px;
}

.publicCheckList {
  list-style: none;
  padding: 0;
  margin: 0;
}

.publicCheckList li {
  position: relative;
  padding: 9px 0 9px 26px;
  color: #52627a;
  font-size: 14px;
  line-height: 1.55;
  border-bottom: 1px solid #edf2f7;
}

.publicCheckList li:last-child {
  border-bottom: 0;
}

.publicCheckList li::before {
  content: "✓";
  position: absolute;
  left: 0;
  top: 10px;
  color: #f1851b;
  font-weight: 800;
  font-size: 16px;
}

.publicCheckList-light li {
  border-bottom-color: rgba(255, 255, 255, 0.12);
}

.publicCheckList-light li::before {
  color: #ffd59f;
}

.publicTimelineWrap {
  padding-bottom: 14px;
}

.publicTimeline {
  position: relative;
  display: grid;
  gap: 14px;
}

.publicTimeline::before {
  content: "";
  position: absolute;
  top: 18px;
  bottom: 18px;
  left: 47px;
  width: 2px;
  background: linear-gradient(180deg, rgba(241, 133, 27, 0.15) 0%, rgba(241, 133, 27, 0.55) 45%, rgba(241, 133, 27, 0.15) 100%);
}

.publicTimeline-item {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 14px;
  align-items: stretch;
}

.publicTimeline-badge {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 14px;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  z-index: 1;
}

.publicTimeline-badge::before {
  content: attr(data-label);
}

.publicTimeline-item .publicTimeline-badge {
  position: relative;
}

.publicTimeline-item .publicTimeline-badge::after {
  content: "";
  position: absolute;
  top: 9px;
  left: 12px;
  right: 12px;
  height: 38px;
  border-radius: 999px;
  background: linear-gradient(135deg, #f59d2a 0%, #f1851b 100%);
  box-shadow: 0 14px 28px rgba(241, 133, 27, 0.22);
  z-index: -1;
}

.publicTimeline-card {
  padding: 18px 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.publicTimeline-card p {
  color: #52627a;
}

.publicPageHeroCenter {
  text-align: center;
  max-width: 820px;
  margin: 0 auto 4px;
}

.publicPageHeroCenter h1 {
  margin-left: auto;
  margin-right: auto;
}

.publicContactGrid {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(280px, 0.82fr);
  gap: 16px;
}

.publicMapCard {
  overflow: hidden;
  background: #fff;
}

.publicMapCard iframe {
  width: 100%;
  min-height: 100%;
}

.publicContactPanel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.publicContactCard {
  padding: 16px 18px;
  background: #fff;
  border-radius: 20px;
  box-shadow: none;
}

.publicContactCard h2 {
  margin: 8px 0 10px;
  color: #1e2a44;
  font-size: 30px;
  font-weight: 800;
}

.publicContactCard a {
  color: #1e2a44;
  text-decoration: none;
  font-weight: 700;
}

.publicCalloutRow {
  display: flex;
}

.publicCallout {
  width: 100%;
  padding: 22px 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.publicButtonLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  margin-top: 18px;
  padding: 0 18px;
  border-radius: 14px;
  background: linear-gradient(135deg, #f59d2a 0%, #f1851b 100%);
  color: #fff !important;
  text-decoration: none !important;
  font-size: 14px;
  font-weight: 800;
  box-shadow: 0 14px 28px rgba(241, 133, 27, 0.22);
}

.serachPanel :deep(.title),
.serachPanel >>> .title {
  display: none !important;
}

.publicLogoCloud {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.publicLogoCloud span {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #e0e7f0;
  color: #52627a;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
}

@media (max-width: 992px) {
  .page-content-wrapper {
    margin-top: 128px;
  }

  .publicHero,
  .publicHighlight-split,
  .publicFeatureGrid-services,
  .publicContactGrid {
    grid-template-columns: 1fr;
  }

  .publicFeatureGrid,
  .publicBulletGrid,
  .publicMiniStats {
    grid-template-columns: 1fr 1fr;
  }

  .publicHero-title {
    font-size: 38px;
  }
}

@media (max-width: 768px) {
  .page-content-wrapper {
    margin-top: 82px;
    padding: 0 10px;
  }

  .publicHero,
  .publicFeatureGrid,
  .publicBulletGrid,
  .publicMiniStats,
  .publicTimeline-item {
    grid-template-columns: 1fr;
  }

  .publicHero-copy,
  .publicHighlight-card,
  .publicContactPanel,
  .publicCallout {
    padding: 18px 16px;
  }

  .publicHero-title,
  .publicSection-head h2,
  .publicPageHeroCenter h1,
  .publicCallout h2,
  .publicHighlight-card h2 {
    font-size: 30px;
  }

  .publicFeatureCard-body h2,
  .publicFeatureCard-body h3 {
    font-size: 22px;
  }

  .publicFeatureCard img {
    height: 180px;
  }

  .publicTimeline::before {
    left: 15px;
  }

  .publicTimeline-item {
    gap: 10px;
  }

  .publicTimeline-badge {
    justify-content: flex-start;
    padding-left: 0;
  }
}
</style>
